<template>
    <div class="home">
        Página em construção.
    </div>
</template>

<script>
export default {
};
</script>